import { Color, setColor } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

interface SEOTableContainerProps {
  borderColor: Color;
}

export const SEOTableContainer = styled.table<SEOTableContainerProps>`
  border-collapse: collapse;
  border-width: 0;

  @media all and (max-width: ${layout.md}) {
    border-bottom: 1px solid ${(props) => setColor(props.borderColor)};
  }
`;
